export const encodeId = (id) => {
    return btoa(id.toString());
};

export const decodeId = (encodedId) => {
    return atob(encodedId);
};